import * as React from "react";
import { Button } from "@/components/ui/button";
import { Mail, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ContactInformation() {
  return <section data-section-id="253448" id="contact-information" className="scroll-mt-28 bg-[#0B1220] px-6 py-16 text-[#F8FAFC] md:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 max-w-3xl">
          <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.22em] text-[#13B8C8]">
            Contact Information
          </p>

          <h2 className="mb-6 text-4xl font-bold tracking-tight text-white md:text-5xl">
            Contact Details
          </h2>

          <p className="text-lg leading-relaxed text-[#CBD5E1]">
            For privacy-related inquiries, data requests, or professional consultations,
            please contact the FETC team through the official channel below.
          </p>
        </div>

        <div className="rounded-2xl border border-[#13B8C8]/20 bg-[#142033] p-8 md:p-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-center">
            <div className="flex gap-5">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-[#13B8C8]/10 text-[#13B8C8]">
                <ShieldCheck className="h-7 w-7" />
              </div>

              <div>
                <h3 className="mb-3 text-2xl font-bold text-white">
                  Privacy and Data Requests
                </h3>

                <p className="max-w-2xl text-base leading-relaxed text-[#CBD5E1]">
                  We handle privacy inquiries, data requests, and business communication
                  through controlled internal channels. Please avoid submitting sensitive
                  financial, authentication, or confidential operational data through
                  public website forms.
                </p>
              </div>
            </div>

            <div className="mx-auto w-full max-w-md rounded-xl border border-[#13B8C8]/15 bg-[#0F172A] p-4 text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#13B8C8]/10 text-[#13B8C8]">
                <Mail className="h-6 w-6" />
              </div>

              <Link to="mailto:ehab.hashiem@fetc.ae" className="block break-words text-lg font-bold text-[#13B8C8] transition-colors hover:text-[#7DE3F0]">
                ehab.hashiem@fetc.ae
              </Link>

              <Button asChild className="mt-6 rounded-md bg-[#0F62FE] px-8 py-2 text-base font-semibold text-white hover:bg-[#0043CE]">
                <Link to="mailto:ehab.hashiem@fetc.ae">Contact FETC</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}